<template>
  <div>
    <div class="bg-white border border-light rounded rounded-md py-3 my-3">
      <h6 class="px-3 font-size-md text-gray600">{{ getWording(menu.menuWording) }}</h6>
      <div class="container-fluid">
        <div class="row no-gutters py-1">
          <div class="col-3 text-center" style="cursor: pointer" v-for="item in menu.function" :key="item.name" @click="redirect(item)">
            <div class="position-relative">
              <b-badge v-if="badges[item.name]" variant="danger" class="px-1 position-absolute rounded-pill font-weight-normal" style="top: 0px; right: 15%; min-width: 16px;">{{ badges[item.name] }}</b-badge>
              <span :class="item.iconClass" class="md-36">
                {{ item.iconName }}
              </span>
            </div>
            {{ getWording(item.wording) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import pageSettingGetter from '@/utils/pageSettingGetter';

export default {
  props: {
    menu: {
      type: Object,
      /* "menuWording":[
       *   {
       *     language: string,
       *     value: string
       *   },
       *   {...}
       * ],
       * "order": number,
       * "function":[
       *   {
       *     "name": string,
       *     "iconClass": string,
       *     "iconName": string,
       *     "order": number,
       *     "wording":[
       *       {
       *         language: string,
       *         value: string
       *       },
       *       {...}
       *     ],
       *   },
       * ],
       */
    },
  },
  data() {
    return {
      defaultLang: '',
    };
  },
  computed: {
    badges() {
      return this.$store.state.badge;
    },
  },
  created() {
    const vm = this;
    vm.$store.dispatch('getPageSetting', 'MemberCentreHomePage')
      .then((setting) => {
        vm.defaultLang = setting.defaultLanguage;
      });
  },
  methods: {
    // 依使用者語系取得文案
    getWording(wordings) {
      const vm = this;
      const wording = pageSettingGetter.getWording(wordings, vm.defaultLang);

      if (!wording) return '';
      return wording;
    },
    // 導向指定頁面
    redirect(func) {
      const vm = this;
      if (func.url) {
        window.open(func.url);
        return;
      }
      vm.$router.push({ path: `/${func.name}`, query: { companyid: vm.$store.state.companyId, membersourceid: vm.$store.state.memberSourceId } });
    },
  },
};
</script>
